import {
    useState,
} from 'react';

type Props = {
    onClose: () => void;
    onSave: (
        data: FormData
    ) => void;
};

export default function GalleryModal({
                                         onClose,
                                         onSave,
                                     }: Props)
{
    const [
        image,
        setImage
    ] = useState<File | null>(
        null
    );

    const [
        preview,
        setPreview
    ] = useState('');

    const [
        link,
        setLink
    ] = useState('');

    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (!image) {

            alert(
                'Please select an image.'
            );

            return;
        }

        const formData =
            new FormData();

        formData.append(
            'image',
            image
        );

        formData.append(
            'link',
            link
        );

        onSave(
            formData
        );
    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                <h2>
                    Add Banner Image
                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    <label>
                        Banner Image
                    </label>

                    {

                        preview && (

                            <img
                                src={
                                    preview
                                }
                                alt=""
                                className="image-preview"
                            />

                        )

                    }

                    <p className="field-hint">
                        Maximum file size: 2MB
                    </p>

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {
                                return;
                            }

                            if (
                                file.size >
                                2 * 1024 * 1024
                            ) {

                                alert(
                                    'Image must be 2MB or smaller.'
                                );

                                return;
                            }

                            setImage(
                                file
                            );

                            setPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}
                        required
                    />

                    <label>
                        Link
                    </label>

                    <input
                        type="text"
                        placeholder="/recipes"
                        value={
                            link
                        }
                        onChange={(e) =>
                            setLink(
                                e.target.value
                            )
                        }
                    />

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={
                                    onClose
                                }
                            >
                                Cancel
                            </button>

                        </div>

                        <div className="right-actions">

                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
